export default "__VITE_ASSET__CfBaqOpB__"